import api from "../../../shared/api.jsx";

export const getAvailableTimeSlots = async (date) => {
  try {
    const response = await api.get(`/call-bookings/time-slots/${date}`);
    return response;
  } catch (error) {
    console.error("Error fetching time slots:", error);
    return {
      success: false,
      error: error.message || "Failed to fetch time slots",
    };
  }
};

export const getBookingStats = async (date) => {
  try {
    const response = await api.get(`/call-bookings/stats/${date}`);
    return response;
  } catch (error) {
    console.error("Error fetching booking stats:", error);
    return {
      success: false,
      error: error.message || "Failed to fetch booking stats",
    };
  }
};

export const getQuoteData = async (quoteId) => {
  try {
    const response = await api.get(`/call-bookings/quote/${quoteId}`);
    return response;
  } catch (error) {
    console.error("Error fetching quote data:", error);
    return {
      success: false,
      error: error.message || "Failed to fetch quote data",
    };
  }
};

export const createCallBooking = async (bookingData) => {
  try {
    const response = await api.post("/call-bookings", bookingData);
    return response;
  } catch (error) {
    console.error("Error creating call booking:", error);
    return {
      success: false,
      error: error.message || "Failed to create call booking",
    };
  }
};

export const getCallBookingById = async (bookingId) => {
  try {
    const response = await api.get(`/call-bookings/${bookingId}`);
    return response;
  } catch (error) {
    console.error("Error fetching call booking:", error);
    return {
      success: false,
      error: error.message || "Failed to fetch call booking",
    };
  }
};

export const getAllCallBookings = async (filters = {}) => {
  try {
    const params = {};
    if (filters.status) params.status = filters.status;
    if (filters.assignedAgentId)
      params.assignedAgentId = filters.assignedAgentId;

    const response = await api.get("/call-bookings", { params });
    return response;
  } catch (error) {
    console.error("Error fetching call bookings:", error);
    return {
      success: false,
      error: error.message || "Failed to fetch call bookings",
    };
  }
};

export const assignAgent = async (bookingId, agentData) => {
  try {
    const response = await api.patch(
      `/call-bookings/${bookingId}/assign`,
      agentData
    );
    return response;
  } catch (error) {
    console.error("Error assigning agent:", error);
    return {
      success: false,
      error: error.message || "Failed to assign agent",
    };
  }
};

export const updateCallBookingStatus = async (bookingId, status) => {
  try {
    const response = await api.patch(`/call-bookings/${bookingId}/status`, {
      status,
    });
    return response;
  } catch (error) {
    console.error("Error updating call booking status:", error);
    return {
      success: false,
      error: error.message || "Failed to update status",
    };
  }
};
